import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
  Modal,
  Table,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import InformationModal from "../components/InformationModal";
import "./EventHandle.css";
import img from '../assets/carImg.png'

const EventHandle = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [mappedUsers, setMappedUsers] = useState([]);
  const [uploadedUsers, setUploadedUsers] = useState([]);
  const [mappedCars, setMappedCars] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCarsModalOpen, setIsCarsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("delete"); // 'delete' or 'add'
  const [communityNo, setCommunityNo] = useState(null);
  const [selectedMappedUsers, setSelectedMappedUsers] = useState([]);
  const [selectedUploadedUsers, setSelectedUploadedUsers] = useState([]);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [nameSearch, setNameSearch] = useState('');
  const [contactSearch, setContactSearch] = useState('');
  const [addressSearch, setAddressSearch] = useState('');
  const [searchColumn, setSearchColumn] = useState(null);
  const [message, setMessage] = useState(""); // State to manage the message
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [addSubTab, setAddSubTab] = useState("list"); // 'list' or 'manual'
  const [manualUserId, setManualUserId] = useState("");
  const [manualUserList, setManualUserList] = useState([]); // Temporary list for batch addition

  const openInfoModal = () => setIsInfoModalOpen(true);
  const closeInfoModal = () => setIsInfoModalOpen(false);

  useEffect(() => {
    const communityNumber = Cookies.get("adminCommunityNO");
    setCommunityNo(communityNumber);
    fetchEvents();
  }, []);

  const unmapCarFromEvent = async (carId) => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/unmap-car?eventId=${selectedEvent.eventId}&auctionListId=${carId}`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href, // Optional: full URL
          },
        }
      );
      openCarsModal(selectedEvent);
      setIsInfoModalOpen(true);
      setModalMessage("Car un-mapped successfully");
      setMessage("Car removed from event successfully"); // Set message
    } catch (error) {
      console.error("Error removing car from event:", error);
      setMessage("Failed to remove car from event");
    }
  };

  const fetchEvents = async () => {
    const communityNumber = Cookies.get("adminCommunityNO");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/events?communityNo=${communityNumber}`,
        {
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href, // Optional: full URL
          }
        }
      );
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const openModal = async (event) => {
    setSelectedEvent(event);
    try {
      const mappedResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users?eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href, // Optional: full URL
          }
        }
      );
      const uploadedResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/uploaded-users?communityNo=${communityNo}&eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href, // Optional: full URL
          }
        }
      );
      const mappedData = await mappedResponse.json();
      setMappedUsers(mappedData);
      const uploadedData = await uploadedResponse.json();
      setUploadedUsers(uploadedData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setIsModalOpen(true);
  };

  const openCarsModal = async (event) => {
    setSelectedEvent(event);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-cars?eventId=${event.eventId}`,
        {
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href, // Optional: full URL
          }
        }
      );
      const data = await response.json();
      setMappedCars(data);
    } catch (error) {
      console.error("Error fetching mapped cars:", error);
    }
    setIsCarsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEvent(null);
    setActiveTab("delete"); // Reset to the default tab
    setSelectedMappedUsers([]);
    setSelectedUploadedUsers([]);
    setIsButtonVisible(false); // Hide buttons
    setMessage(""); // Clear message
  };

  const closeCarsModal = () => {
    setIsCarsModalOpen(false);
    setSelectedEvent(null);
    setMessage(""); // Clear message
  };

  const handleMappedUserSelect = (userId) => {
    if (selectedMappedUsers.includes(userId)) {
      setSelectedMappedUsers(selectedMappedUsers.filter((id) => id !== userId));
    } else {
      setSelectedMappedUsers([...selectedMappedUsers, userId]);
    }
    setIsButtonVisible(true);
  };

  const handleUploadedUserSelect = (userId) => {
    if (selectedUploadedUsers.includes(userId)) {
      setSelectedUploadedUsers(selectedUploadedUsers.filter((id) => id !== userId));
    } else {
      setSelectedUploadedUsers([...selectedUploadedUsers, userId]);
    }
    setIsButtonVisible(true);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setIsButtonVisible(false);
    setSelectedMappedUsers([]);
    setSelectedUploadedUsers([]);
    setAddSubTab("list"); // Reset to list view
    setManualUserId(""); // Clear manual user ID
    setManualUserList([]); // Clear manual user list
    setMessage(""); // Clear message
  };

  const removeSelectedUsersFromEvent = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/delete`,
        {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href, // Optional: full URL
          },
          body: JSON.stringify({
            eventId: selectedEvent.eventId,
            userIds: selectedMappedUsers,
          }),
        }
      );
      setMappedUsers(
        mappedUsers.filter((user) => !selectedMappedUsers.includes(user.id))
      );
      openModal(selectedEvent);
      setSelectedMappedUsers([]);
      setIsButtonVisible(false);
      // setMessage(<span style={{color:"#ee373b"}}>Selected customers removed</span>);
      // setTimeout(()=>{
      //   setMessage("");
      // }, 5000);
      setIsInfoModalOpen(true);
      setModalMessage("Selected Customer(s) deleted from event.");
    } catch (error) {
      console.error("Error removing users:", error);
    }
  };

  const addSelectedUsersToEvent = async () => {
    try {
      await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/mapped-users/add`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href, // Optional: full URL
          },
          body: JSON.stringify({
            eventId: selectedEvent.eventId,
            userIds: selectedUploadedUsers,
          }),
        }
      );
      setUploadedUsers(
        uploadedUsers.filter(
          (user) => !selectedUploadedUsers.includes(user.LenderBuyerId)
        )
      );
      setSelectedUploadedUsers([]);
      setIsButtonVisible(false);
      openModal(selectedEvent);
      // setMessage(<span style={{color:"#ee373b"}}>Selected customers added</span>);
      // setTimeout(()=>{
      //   setMessage("");
      // }, 5000);
      setIsInfoModalOpen(true);
      setModalMessage("Selected Customer(s) added to event.");
    } catch (error) {
      console.error("Error adding users:", error);
    }
  };

  const addToManualUserList = () => {
    if (!manualUserId) return;

    // Split by comma, trim, and deduplicate within the input string
    const inputIds = manualUserId.split(",").map(id => id.trim()).filter(id => id.length === 7);
    const uniqueInputIds = [...new Set(inputIds)];

    if (uniqueInputIds.length === 0) return;

    // Filter out IDs that are already in the temporary list
    const newIds = uniqueInputIds.filter(id => !manualUserList.includes(id));

    if (newIds.length > 0) {
      setManualUserList([...manualUserList, ...newIds]);
    }

    // Clear input after processing
    setManualUserId("");
  };

  const removeFromManualUserList = (idToRemove) => {
    setManualUserList(manualUserList.filter(id => id !== idToRemove));
  };

  const addManualUsersToEvent = async () => {
    if (manualUserList.length === 0) {
      setIsInfoModalOpen(true);
      setModalMessage("Please add at least one user ID to the list");
      return;
    }

    let successCount = 0;
    let failCount = 0;
    let errorMessages = [];

    for (const uniqueId of manualUserList) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/lender/dashboard/manual-user/add`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "X-Full-URL": window.location.href,
            },
            body: JSON.stringify({
              eventId: selectedEvent.eventId,
              uniqueId: uniqueId,
              communityNo: parseInt(communityNo),
            }),
          }
        );

        const data = await response.json();

        if (response.ok && data.success) {
          successCount++;
        } else {
          failCount++;
          errorMessages.push(`ID ${uniqueId}: ${data.message || "Failed"}`);
        }
      } catch (error) {
        console.error(`Error adding manual user ${uniqueId}:`, error);
        failCount++;
        errorMessages.push(`ID ${uniqueId}: Network error`);
      }
    }

    // Show summary
    let summaryMessage = `Successfully added ${successCount} user(s).`;
    if (failCount > 0) {
      summaryMessage += ` ${failCount} failed.\n${errorMessages.join("\n")}`;
    }

    setIsInfoModalOpen(true);
    setModalMessage(summaryMessage);

    // Clear the list and refresh
    setManualUserList([]);
    setManualUserId("");
    openModal(selectedEvent);
  };

  const filteredUploadedUsers = uploadedUsers.filter(
    (user) =>
      (searchColumn === 'name' ? user.name.toLowerCase().includes(nameSearch.toLowerCase()) : true) &&
      (searchColumn === 'contact' ? user.PrimaryPhone.includes(contactSearch) : true) &&
      (searchColumn === 'address' ? user.ContactAddress.toLowerCase().includes(addressSearch.toLowerCase()) : true)
  );

  const filteredMappedUsers = mappedUsers.filter(
    (user) =>
      (searchColumn === 'name' ? user.customer_name.toLowerCase().includes(nameSearch.toLowerCase()) : true) &&
      (searchColumn === 'contact' ? user.customer_contactnumber.includes(contactSearch) : true)
  );

  return (
    <div style={{ height: "82vh", borderRadius: "20px", border: "2px solid #ee373b", margin: "10px" }}>
      <InformationModal
        isOpen={isInfoModalOpen}
        onClose={closeInfoModal}
        message={modalMessage}
      />
      <div style={{ backgroundColor: "#ee373b", padding: "5px", borderTopLeftRadius: "18px", borderTopRightRadius: "18px", textAlign: "center" }}>
        <p style={{ color: "white", fontWeight: "bold", fontSize: "24px", margin: "0px" }}>Event Management</p>
      </div>
      <div style={{ maxHeight: "65vh", overflowY: "scroll", marginTop: "5vh", scrollbarWidth: "thin", scrollbarColor: "#ee373b #ffffff", padding: "0px 10px" }}>
        <table
          className="table table-striped"
        >
          <thead style={{ position: "sticky", top: "0" }}>
            <tr>
              <th>Event Title</th>
              <th>Location</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Actions</th>
              <th>View Cars</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.eventId}>
                <td>{event.eventTitle}</td>
                <td>{event.location}</td>
                <td>{new Date(event.startDateAndTime).toLocaleString()}</td>
                <td>{new Date(event.endDateAndTime).toLocaleString()}</td>
                <td>
                  <Button variant="danger" onClick={() => openModal(event)}>
                    View Customers
                  </Button>
                </td>
                <td>
                  <Button
                    variant="outline-danger"
                    onClick={() => openCarsModal(event)}
                  >
                    View Cars
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        show={isModalOpen}
        onHide={closeModal}
        size="lg"
        id="modal-custom"
        style={{ maxHeight: "100vh", overflowY: "auto" }}
      >
        <Modal.Header style={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px", borderTop: "2px solid #ee373b", borderLeft: "2px solid #ee373b", borderRight: "2px solid #ee373b" }}>
          <Modal.Title className="text-white mx-3" style={{ fontSize: "20px", fontWeight: "bold", textAlign: "left" }}>
            {"Manage Customer - "}{selectedEvent?.eventTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="model-body" style={{ maxHeight: "46vh", borderLeft: "2px solid #ee373b", borderRight: "2px solid #ee373b" }}>
          <ul className="nav nav-tabs" style={{ borderBottom: "2px solid #ee373b" }}>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "add" ? "active" : ""}`}
                style={{ border: "1px solid #ee373b" }}
                onClick={() => setActiveTab("add")}
              >
                Add Customers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "delete" ? "active" : ""}`}
                style={{ border: "1px solid #ee373b" }}
                onClick={() => setActiveTab("delete")}
              >
                Delete Customers
              </button>
            </li>
            {message && (
              <li className="nav-item ml-auto">
                <span className="nav-link text-success">{message}</span>
              </li>
            )}
          </ul>

          {activeTab === "delete" && (
            <div style={{ maxHeight: "200px", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe" }}>
              <Table
                striped
                bordered
                hover
                className="mt-3"
                id="mapped-user-table"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#fff",
                    zIndex: 2,
                  }}
                >
                  <tr>
                    <th style={{ padding: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>Name</span>
                        <input
                          placeholder="Search..."
                          className="input"
                          name="text"
                          type="text"
                          value={nameSearch}
                          onChange={(e) => {
                            setNameSearch(e.target.value);
                            setSearchColumn("name");
                          }}
                          style={{ marginLeft: "39px", zIndex: 1 }}
                        />
                      </div>
                    </th>
                    <th style={{ padding: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>Contact</span>
                        <input
                          placeholder="Search..."
                          className="input"
                          name="text"
                          type="text"
                          value={contactSearch}
                          onChange={(e) => {
                            setContactSearch(e.target.value);
                            setSearchColumn("contact");
                          }}
                          style={{ marginLeft: "25px", zIndex: 1 }}
                        />
                      </div>
                    </th>
                    <th style={{ width: "10%", padding: "10px" }}>Select</th>
                  </tr>
                </thead>
                <tbody
                  id="modal-table-custom"
                >
                  {filteredMappedUsers.map((user) => (
                    <tr
                      key={user.id}
                    // style={{ display: "table", width: "100%" }}
                    >
                      <td >{user.customer_name}</td>
                      <td >
                        {user.customer_contactnumber}
                      </td>
                      <td >
                        <Form.Check
                          type="checkbox"
                          id="custom-checkbox"
                          checked={selectedMappedUsers.includes(user.id)}
                          onChange={() => handleMappedUserSelect(user.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {activeTab === "add" && (
            <div className="d-flex" style={{ borderBottom: "1px solid #dee2e6", marginTop: "10px" }}>
              <button
                className={`btn btn-sm ${addSubTab === "list" ? "btn-danger" : "btn-outline-danger"}`}
                style={{ marginRight: "5px", marginBottom: "5px" }}
                onClick={() => setAddSubTab("list")}
              >
                Select from List
              </button>
              <button
                className={`btn btn-sm ${addSubTab === "manual" ? "btn-danger" : "btn-outline-danger"}`}
                style={{ marginBottom: "5px" }}
                onClick={() => setAddSubTab("manual")}
              >
                Add Manual by ID
              </button>
            </div>
          )}

          {activeTab === "add" && addSubTab === "list" && (
            <div style={{ maxHeight: "200px", overflowY: "scroll", overflowX: "hidden", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe" }}>
              <Table
                striped
                bordered
                hover
                className="mt-3"
                id="normal-user-table"
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#fff",
                    zIndex: 2,
                  }}
                >
                  <tr>
                    <th style={{ padding: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>Name</span>
                        <input
                          placeholder="Search..."
                          className="input"
                          name="text"
                          type="text"
                          value={nameSearch}
                          onChange={(e) => {
                            setNameSearch(e.target.value);
                            setSearchColumn("name");
                          }}
                          style={{ marginLeft: "39px", zIndex: 1 }}
                        />
                      </div>
                    </th>
                    <th style={{ padding: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span>Contact</span>
                        <input
                          placeholder="Search..."
                          className="input"
                          name="text"
                          type="text"
                          value={contactSearch}
                          onChange={(e) => {
                            setContactSearch(e.target.value);
                            setSearchColumn("contact");
                          }}
                          style={{ marginLeft: "25px", zIndex: 1 }}
                        />
                      </div>
                    </th>
                    <th style={{ width: "10%", padding: "10px" }}>Select</th>
                  </tr>
                </thead>
                <tbody
                  id="modal-table-custom"
                  style={{
                    // display: "block",
                    maxHeight: "150px",
                    // minWidth: "42.5vw",
                    overflowY: "scroll",
                    // scrollbarWidth: "none",
                  }}
                >
                  {filteredUploadedUsers.map((user) => (
                    <tr
                      key={user.LenderBuyerId}
                      style={{
                        // display: "table",
                        width: "100%",
                        // tableLayout: "fixed",
                      }}
                    >
                      <td>{user.name}</td>
                      <td>{user.PrimaryPhone}</td>
                      <td>
                        <Form.Check
                          type="checkbox"
                          id="custom-checkbox"
                          checked={selectedUploadedUsers.includes(
                            user.LenderBuyerId
                          )}
                          onChange={() =>
                            handleUploadedUserSelect(user.LenderBuyerId)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {activeTab === "add" && addSubTab === "manual" && (
            <div style={{ padding: "20px" }}>
              <div style={{ marginBottom: "15px", textAlign: "center" }}>
                <label style={{ fontWeight: "bold", marginBottom: "10px", display: "block" }}>
                  Enter Unique ID
                </label>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter 7-digit unique ID(s) (comma separated)"
                    value={manualUserId}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow digits and commas
                      if (/^[0-9,]*$/.test(value)) {
                        const segments = value.split(",");
                        // Each segment except the last one must be exactly 7 digits
                        // The last segment can be 0-7 digits
                        const isValid = segments.every((seg, idx) => {
                          if (idx === segments.length - 1) {
                            return seg.length <= 7;
                          }
                          return seg.length === 7;
                        });

                        if (isValid) {
                          setManualUserId(value);
                        }
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' && manualUserId) {
                        addToManualUserList();
                      }
                    }}
                    style={{ width: "350px", textAlign: "center" }}
                  />
                  <Button
                    variant="danger"
                    onClick={addToManualUserList}
                    disabled={!manualUserId}
                    size="sm"
                  >
                    Add to List
                  </Button>
                </div>
              </div>

              {manualUserList.length > 0 && (
                <div style={{ maxHeight: "200px", overflowY: "scroll", overflowX: "hidden", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe" }}>
                  <Table
                    striped
                    bordered
                    hover
                    className="mt-3"
                    style={{ tableLayout: "fixed", width: "100%" }}
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        background: "#fff",
                        zIndex: 2,
                      }}
                    >
                      <tr>
                        <th style={{ padding: "10px", width: "70%" }}>Unique ID</th>
                        <th style={{ padding: "10px", width: "30%" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody id="modal-table-custom">
                      {manualUserList.map((id, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{id}</td>
                          <td style={{ textAlign: "center" }}>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => removeFromManualUserList(id)}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}

              {manualUserList.length === 0 && (
                <div style={{ textAlign: "center", color: "#999", marginTop: "20px" }}>
                  <p>No users added yet. Enter a 7-digit ID and click "Add to List".</p>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {activeTab === "delete" ? (
            <Button
              variant="danger"
              onClick={removeSelectedUsersFromEvent}
              disabled={selectedMappedUsers.length === 0}
            >
              Delete Selected
            </Button>
          ) : addSubTab === "list" ? (
            <Button
              variant="danger"
              onClick={addSelectedUsersToEvent}
              disabled={selectedUploadedUsers.length === 0}
            >
              Add Selected
            </Button>
          ) : addSubTab === "manual" ? (
            <Button
              variant="danger"
              onClick={addManualUsersToEvent}
              disabled={manualUserList.length === 0}
            >
              Add Customers ({manualUserList.length})
            </Button>
          ) : null}
          <Button variant="outline-danger" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isCarsModalOpen}
        onHide={closeCarsModal}
        size="lg"
        id="modal-custom"
        style={{ marginTop: "5vh", maxHeight: "100vh" }}
        className="modal-dialog-centered"
      >
        <div className="p-2" style={{ backgroundColor: "#ee373b", borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}>
          <h1 className="text-white m-2" style={{ fontSize: "20px", fontWeight: "bold" }}>
            Mapped Cars for Event: {selectedEvent?.eventTitle}
          </h1>
          {/* <button onClick={closeCarsModal} className="ml-auto bg-transparent" style={{border:"0px"}}>
            <span style={{ color:"white", fontSize: "36px" }}>&#11199;</span>
          </button> */}
        </div>
        {/* <Modal.Header>
          
        </Modal.Header> */}
        <Modal.Body
          id="model-body"
          style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#ee373b #fefefe", borderLeft: "2px solid #ee373b", borderRight: "2px solid #ee373b" }}
        >
          <div className="row">
            {mappedCars.length > 0 &&
              mappedCars.map((car) => (
                <div key={car.auctionListId} className="col-md-12 mb-3">
                  <div className="card">
                    <div className="">
                      <div className="d-flex justify-content-between">
                        <div className="" style={{ width: `${100 / 12}%` }}>
                          <div className="card__image-container">
                            <div
                              className="card__image"
                              style={{
                                backgroundImage:
                                  car.images != undefined
                                    ? `url(${car.images[0]})`
                                    : "",
                              }}
                            ></div>
                          </div>
                        </div>
                        <div
                          className=""
                          style={{
                            width: `${11 * (100 / 12)}%`,
                            alignItems: "center",
                            textAlign: "center",
                            display: "grid",
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div
                              className=""
                              style={{ width: `${5 * (100 / 12)}%` }}
                            >
                              <div className="card__text">
                                <span className="text-dark">
                                  {car.MakeAndModel}
                                </span>
                                <span className="text-dark">
                                  {car.variant || "N/A"}
                                </span>
                                <span className="text-dark">
                                  {car.body || "N/A"}
                                </span>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="card__text">
                                <p className="card__description text-dark">
                                  <span>{car.location || "N/A"}</span>
                                </p>
                              </div>
                            </div>
                            <div className="col-1">
                              <div className="car-specs">
                                <div className="card__text text-dark">
                                  <span>{car.YearOld || "N/A"}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="car-specs">
                                <div className="car-spec-item">
                                  <span className="card__text text-dark">
                                    <span>
                                      ₹
                                      {car.StartPrice
                                        ? car.StartPrice.toLocaleString()
                                        : "N/A"}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* <div className="col-1">
                              <Button
                                variant="danger"
                                size="sm"
                                className="unmap-button"
                                onClick={() =>
                                  unmapCarFromEvent(car.AuctionListId)
                                }
                              >
                                <span>&#11199;</span>
                              </Button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          {mappedCars.length === 0 && (
            <div className="text-center py-4">
              <p>No cars mapped to this event.</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
          <button className="btn btn-danger" onClick={closeCarsModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EventHandle;
